export default __webpack_public_path__ + "static/media/icon_personal_details.55d9d3e9.svg";